import React, { Component } from "react";
import {
  View,
  TouchableHighlight,
  Dimensions,
  StyleSheet,
} from "react-native";
import Text from "../components_v2/TextFont";
import PropTypes from "prop-types";

import { translate } from "../locales/translate";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faCalendarWeek,
  faCheck,
  faEdit,
} from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import Select from "../nativeBase-ui/Select";
let moment = require("moment-jalaali");

/**@augments{Component<Props,state>} */
class MonthPicker extends Component {
  static propTypes = {
    minYear: PropTypes.number.isRequired,
    maxYear: PropTypes.number.isRequired,
    monthNames: PropTypes.arrayOf(PropTypes.string),
    selectedStartYear: PropTypes.number,
    selectedStartMonth: PropTypes.number,
    selectedEndYear: PropTypes.number,
    selectedEndMonth: PropTypes.number,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    let {
      minYear,
      maxYear,
      monthNames,
      selectedStartMonth,
      selectedEndMonth,
      selectedStartYear,
      selectedEndYear,
    } = this.props;
    if (!monthNames || monthNames.length == 0) {
      monthNames = [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ];
    }

    this.state = {
      minYear,
      maxYear,
      monthNames,
      selectedStartMonth: selectedStartMonth || 1,
      selectedEndMonth:
        selectedEndMonth || Number(moment(new Date().toString()).format("jM")),
      selectedStartYear: selectedStartYear || maxYear,
      selectedEndYear: selectedEndYear || maxYear,
      showSelectors: false,
    };
  }

  handleStartChange = (year, month) => {
    this.setState(
      { selectedStartYear: year, selectedStartMonth: month },
      () => {
        typeof this.props.onStartChange === "function" &&
          this.props.onStartChange(year, month);
      }
    );
  };

  handleEndChange = (year, month) => {
    this.setState({ selectedEndYear: year, selectedEndMonth: month }, () => {
      typeof this.props.onEndChange === "function" &&
        this.props.onEndChange(year, month);
    });
  };

  render() {
    let { minYear, maxYear } = this.props;
    let { monthNames } = this.state;
    let _style = this.props.style || {};
    if (!minYear || !maxYear || !monthNames || monthNames.length == 0)
      return null;

    return (
      <View style={{ ..._style }}>
        <View style={styles.wrapper}>
          <View style={styles.summaryWrapper}>
            <TouchableHighlight
              style={{
                marginEnd: 12,
                
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#d9f9ff",
                borderRadius: 5,
                marginHorizontal: 10,
              }}
              underlayColor="#fff"
              onPress={() => {
                //this.setState({ showSelectors: true });
              }}
            >
              <View>
                <FontAwesomeIcon
                  icon={faCalendarWeek}
                  color={Theme.COLORS.INFO}
                  size={32}
                />
              </View>
            </TouchableHighlight>
            <Text
              style={styles.summary}
              onPress={() => {
                //this.setState({ showSelectors: true });
              }}
            >
              {translate("deviceLog.fromBeginning")}
              <Text style={{ fontWeight: "bold" }}>
                {this.state.selectedStartYear}/{this.state.selectedStartMonth}{" "}
              </Text>
              {translate("deviceLog.toEndOf")}
              <Text style={{ fontWeight: "bold" }}>
                {this.state.selectedEndYear}/{this.state.selectedEndMonth}
              </Text>
            </Text>

            {!this.state.showSelectors && (
              <TouchableHighlight
                style={styles.EditButton}
                onPress={() => {
                  this.setState({ showSelectors: true });
                }}
              >
                <FontAwesomeIcon icon={faEdit} color="#FFF" />
              </TouchableHighlight>
            )}
            {this.state.showSelectors && (
              <TouchableHighlight
                style={[
                  styles.EditButton,
                  {
                    alignSelf: "flex-end",
                    backgroundColor: Theme.COLORS.SUCCESS,
                  },
                ]}
                onPress={() => {
                  this.setState({ showSelectors: false }, () => {
                    let {
                      selectedEndMonth,
                      selectedEndYear,
                      selectedStartMonth,
                      selectedStartYear,
                    } = this.state;
                    typeof this.props.onChange === "function" &&
                      this.props.onChange({
                        endMonth: selectedEndMonth,
                        endYear: selectedEndYear,
                        startMonth: selectedStartMonth,
                        startYear: selectedStartYear,
                      });
                  });
                }}
              >
                <FontAwesomeIcon icon={faCheck} color="#FFF" />
              </TouchableHighlight>
            )}
          </View>
          {this.state.showSelectors && (
            <View style={{ marginTop: 10 }}>
              <Selector
                minYear={minYear}
                maxYear={maxYear}
                monthNames={monthNames}
                selectedMonth={
                  this.props.selectedStartMonth || this.state.selectedStartMonth
                }
                selectedYear={
                  this.props.selectedStartYear || this.state.selectedStartYear
                }
                type="start"
                onChange={(year, month) => {
                  this.setState({
                    selectedStartMonth: month,
                    selectedStartYear: year,
                  });
                }}
              />
              <Selector
                minYear={minYear}
                maxYear={maxYear}
                monthNames={monthNames}
                selectedMonth={
                  this.props.selectedEndMonth || this.state.selectedEndMonth
                }
                selectedYear={
                  this.props.selectedEndYear || this.state.selectedEndYear
                }
                type="end"
                onChange={(year, month) => {
                  this.setState({
                    selectedEndMonth: month,
                    selectedEndYear: year,
                  });
                }}
              />
            </View>
          )}
        </View>
      </View>
    );
  }
}

/**@augments{Component<Props,state>} */
class Selector extends Component {
  static propTypes = {
    monthNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    minYear: PropTypes.number.isRequired,
    maxYear: PropTypes.number.isRequired,
    selectedYear: PropTypes.number,
    selectedMonth: PropTypes.number,
    type: PropTypes.oneOf(["start", "end"]),
    onChange: PropTypes.func,
  };
  constructor(props) {
    super(props);
    let { minYear, maxYear, selectedYear, selectedMonth, type } = this.props;
    this.state = {
      type,
      selectedYear: selectedYear || maxYear, // type == "start" ? minYear : maxYear
      selectedMonth:
        selectedMonth || type == "start"
          ? 1
          : Number(moment(new Date().toString()).format("jM")),
    };
  }

  twoDigit(num) {
    if (num < 0 || num > 99) return num;
    return (100 + num).toString().substr(1);
  }

  handleOnChange(year, month) {
    this.setState({ selectedYear: year, selectedMonth: month }, () => {
      typeof this.props.onChange === "function" &&
        this.props.onChange(year, month);
    });
  }
  render() {
    let { minYear, maxYear, monthNames } = this.props;
    let years = [];
    for (let y = minYear; y <= maxYear; y++) {
      years.push(y);
    }
    return (
      <View style={styles.selectorWrapper}>
        <Text style={styles.selectorText}>
          {this.state.type == "start"
            ? translate("deviceLog.fromBeginning")
            : translate("deviceLog.toEndOf")}
        </Text>
        <Select
          data={monthNames.map((m, i) => {
            return {
              label: m,
              value: i + 1,
            };
          })}
          value={this.state.selectedMonth}
          containerStyle={styles.selectorDropdown}
          onChangeText={(value) => {
            this.handleOnChange(this.state.selectedYear, value);
          }}
        />
        <Text>/</Text>
        <Select
          data={years.map((y) => {
            return {
              label: y,
              value: y,
            };
          })}
          value={this.state.selectedYear}
          containerStyle={styles.selectorDropdown}
          onChangeText={(value) => {
            this.handleOnChange(value, this.state.selectedMonth);
          }}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    //flexDirection: "row",
    //justifyContent: "space-around",
    paddingVertical: 15,
    margin: 10,
    paddingBottom: 0,
    marginBottom: 0,
    //backgroundColor: "#e2e2e2",
  },
  summaryWrapper: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: 10,
  },
  summary: {
    fontSize: 14,
  },
  selectorWrapper: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 15,
  },
  selectorDropdown: { width: 120 },
  selectorText: { width: 70 },
  EditButton: {
    marginHorizontal: 10,
    backgroundColor: Theme.COLORS.WARNING,
    borderRadius: 15,
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    //alignSelf: "flex-end",
  },
});

export default MonthPicker;
